export default __webpack_public_path__ + "static/media/img-2.7877f780.jpg";